import * as React from 'react'
import { closeIncomingSelfBillingOrderModal, showAttachmentsViewerModal, showContactModal, } from '../../store/modals/actions'
import Icon from '../Icons/Icon'
import Notification from '../../utilities/Notification'
import { IncomingSelfBillingOrdersController } from '../../controllers'
import { AppState } from '../../store'
import { AnyAction, Dispatch } from 'redux'
import { connect } from 'react-redux'
import { withRouter, RouteComponentProps } from 'react-router'
import DateInput, { DateInput as DateInputClass } from '../Form/DateInput'
import moment from '../../utilities/Moment'
import MoneyInput from '../Form/MoneyInput'
import styled, { css } from 'styled-components'
import { Style } from '../../styles'
import { withTranslation, WithTranslation } from 'react-i18next'
import Tooltip from '../Tooltips/Tooltip'
import NumberFormatter from '../../utilities/NumberFormatter'
import ResourceCreatablePowerSelect from '../Form/ResourceCreatablePowerSelect'
import AttachmentPreviewer from './AttachmentsViewer/AttachmentsPreviewer'
import SidebarClose from '../Sidebar/SidebarClose'
import SidebarContent from '../Sidebar/SidebarContent'
import SidebarContainerComponent from '../Sidebar/SidebarContainer'
import SidebarDivider from '../Sidebar/SidebarDivider'
import TooltipError from '../Tooltips/ErrorTooltip'
import Button from '../Button/Button'
import SidebarFooterComponent from '../Sidebar/SidebarFooter'
import Loader from '../Loaders/Loader'
import { Contact, CurrentUser, CustomField, IncomingSelfBillingOrder, IncomingSelfBillingOrderType, PreviewAttachment } from '../../types'
import { saveAs } from 'file-saver'
import RemittanceInformationInput from '../Form/RemittanceInformationInput'
import PowerSelect from '../Form/PowerSelect'
import ReactSelectTheme from '../Form/ReactSelectTheme'
import IncomingSelfBillingOrderHelper from '../../helpers/IncomingSelfBillingOrderHelper'
import SimpleTooltip from '@/components/Tooltips/SimpleTooltip'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;
  width: 100%;

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    height: 100%;
  }
`

const SidebarContainer = styled(SidebarContainerComponent)`
  width: 497px;
  min-width: 497px;

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    width: 100%;
    min-width: initial;
  }
`

const SidebarFooter = styled(SidebarFooterComponent)`
  display: flex;
  flex-direction: row;
  gap: 8px;

  > * {
    flex: 1;
    width: 100%;
  }
`

const LoaderContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`

const PreviewContainer = styled.div`
  position: relative;
	height: 100%;
  width: 100%;
  pointer-events: all;
  cursor: auto;

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    display: none;
  }
`

const PreviewDropzoneContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  pointer-events: all;

  > div {
    border: none;
    height: 100vh;
  }
`

const PreviewWrapper = styled.div<{ noPadding?: boolean }>`
 	padding: 48px 24px;
	outline: none !important;
  overflow: auto;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) => props.noPadding && css`
    padding: 0;
  `}



	img, iframe {
		border-radius: 3px;
		width: 100%;
    max-width: 100%;
    position: relative;
    transition: transform .15s,opacity .4s;
    cursor: auto;
    pointer-events: all;
	}

	iframe {
		height: 100vh;
		border: none;
	}
`

const PreviewAction = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  color: white;
  flex: 1;
  cursor: pointer;
  font-size: 14px;
  text-align: center;
  min-width: 67px;
  width: 67px;
  font-weight: 500;

  svg, i {
    color: white;
    fill: white;
  }

  svg {
    width: 18px;
    height: 18px;
  }

  i {
    font-size: 18px;
  }

  &:hover {
    opacity: 0.8;
  }
`

const PreviewActions = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  gap: 24px;
  background: #3d3d3d;
  border-radius: 8px;
`

const AttachmentExpand = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	width: 44px;
	height: 44px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${Style.color.brandPrimary};
	color: white;
	border-radius: 50%;
	transition: transform 0.1s ease 0s;
	transform: translate(-50%, -50%) scale(0);

	@media screen and (max-width: ${Style.breakpoints.SMALL}) {
		transform: translate(-50%, -50%) scale(1);
	}

	i {
		font-size: 20px;
		fill: currentColor;
	}
`

const AttachmentPreviewContainer = styled.div`
	position: relative;
	max-width: 100%;
  min-height: 250px;
	padding-bottom: 31px;
	cursor: pointer;
  display: none;

	&:hover {
		${AttachmentExpand} {
			transform: translate(-50%, -50%) scale(1);
		}
	}

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    display: block;
  }

  iframe {
    width: 100%;
    min-height: 250px;
  }
`

const AttachmentPreviewDelete = styled.a`
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 32px;
	background-color: ${Style.color.brandDanger};
	font-weight: 600;
	color: #FFF;
	border-bottom-left-radius: 3px;
	border-bottom-right-radius: 3px;
`

const EditCategoryImage = styled.div`
  justify-self: flex-end;
  cursor: pointer;

  svg, i {
    color: rgb(204, 204, 204);
    fill: rgb(204, 204, 204);
  }
`

const ExtractionMetadata = styled.div`
  margin-top: ${Style.spacing.x1};

  a {
    text-decoration: underline;
  }
`

const ExtractionMetadataWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

const ExtractionMetadataContent = styled.div`
  .tooltip-info-icon {
    color: rgb(133, 100, 4);
  }
`

const MobileIncomingSelfBillingModalDropzone = styled.div`
  display: none;

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    display: block;
  }
`

const PayWithQRCodeLink = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-top: 4px;
  color: ${Style.color.brandPrimary};
  font-size: 14px;

  @media screen and (max-width: ${Style.breakpoints.SMALL}) {
    display: none;
    
  }

  svg, i {
    margin-right: ${Style.spacing.x1};
    color: ${Style.color.brandPrimary};
    fill: ${Style.color.brandPrimary};
  }

  &:hover {
    text-decoration: underline;
  }

`

const IncomingSelfBillingOrderHeader = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 8px;
`

const IncomingSelfBillingOrderHeaderTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 30px;
  font-weight: 700;
  color: black;
  font-weight: 900;
  font-family: 'Inter', sans-serif;
  margin-bottom: ${Style.spacing.x2};
  padding-right: 40px;

  span {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    overflow: hidden;
  }
`

const IncomingSelfBillingOrderHeaderAmountContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 4px;

`
const IncomingSelfBillingOrderHeaderAmount = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: normal;

`

const IncomingSelfBillingOrderHeaderVatDescription = styled.div`
  font-weight: 400;
  color: rgb(72, 72, 72);
`

const IncomingSelfBillingOrderSectionTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  margin-bottom: ${Style.spacing.x2};
`

interface IStateToProps {
  currentUser: CurrentUser
  incomingSelfBillingOrder?: IncomingSelfBillingOrder
  supplierDisabled?: boolean
  contactDisabled?: boolean
  projectDisabled?: boolean
  onSubmit?: (incomingSelfBillingOrder: IncomingSelfBillingOrder) => void
}

interface IDispatchToProps {
  close: typeof closeIncomingSelfBillingOrderModal
  showAttachmentsViewerModal: typeof showAttachmentsViewerModal
  showContactModal: typeof showContactModal
}

type IProps = IDispatchToProps & IStateToProps & WithTranslation & RouteComponentProps<any>

interface IState {
  didInitialLoad: boolean
  incomingSelfBillingOrder: IncomingSelfBillingOrder | null
  currencies: { label: string, value: string, symbol: string }[]
  customFields: CustomField[]
  errors: any
  isSubmitting: boolean
  extractingData: boolean
}

class IncomingSelfBillingModal extends React.Component<IProps, IState> {
  private netAmountInput = React.createRef<MoneyInput>()
  private amountInput = React.createRef<MoneyInput>()
  private invoicedOnInput = React.createRef<DateInputClass>()
  private dueOnInput = React.createRef<DateInputClass>()
  private paidOnInput = React.createRef<DateInputClass>()

  constructor(props: IProps) {
    super(props)

    this.state = {
      didInitialLoad: false,
      incomingSelfBillingOrder: null,
      currencies: [],
      customFields: [],
      errors: {},
      isSubmitting: false,
      extractingData: false,
    }

    this.fetchForm = this.fetchForm.bind(this)
    this.onFileDownloadClick = this.onFileDownloadClick.bind(this);
    this.onFileExpandClick = this.onFileExpandClick.bind(this)
    this.onContactChange = this.onContactChange.bind(this)
    this.onPaidOnChange = this.onPaidOnChange.bind(this)
    this.onBookedOnChange = this.onBookedOnChange.bind(this)
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onIncomingSelfBillingModalClose = this.onIncomingSelfBillingModalClose.bind(this)
    this.onErrorsDismiss = this.onErrorsDismiss.bind(this)
  }

  componentDidMount() {
    this.fetchForm()
  }

  async fetchForm() {
    try {
      const { incomingSelfBillingOrder: propIncomingSelfBillingOrder } = this.props

      const response = await IncomingSelfBillingOrdersController.getForm(propIncomingSelfBillingOrder.id)

      const { incoming_self_billing_order, categories, currencies, custom_fields } = response

      this.setState({
        incomingSelfBillingOrder: {
          ...incoming_self_billing_order,
          ...propIncomingSelfBillingOrder,
          reviewed: true,
        },
        currencies: currencies,
        customFields: custom_fields,
        didInitialLoad: true
      })

    } catch (ex) {
      console.error(ex)
    }
  }

  onFileDownloadClick() {
    const { incomingSelfBillingOrder } = this.state

    if (incomingSelfBillingOrder.attachment_download_url) {
      saveAs(incomingSelfBillingOrder.attachment_download_url, incomingSelfBillingOrder.attachment_file_name)
    }
  }

  onFileExpandClick(e) {
    e.preventDefault()
    const { t } = this.props
    const { incomingSelfBillingOrder } = this.state

    const attachments: PreviewAttachment[] = [
      {
        id: incomingSelfBillingOrder.id,
        name: incomingSelfBillingOrder.attachment_file_name,
        url: incomingSelfBillingOrder.attachment_url,
        file_size: incomingSelfBillingOrder.attachment_file_size,
        content_type: incomingSelfBillingOrder.attachment_content_type,
        created_at: incomingSelfBillingOrder.created_at
      }
    ]

    this.props.showAttachmentsViewerModal({
      attachments: attachments,
      actions: [{
        icon: 'external-link', text: t('IncomingSelfBillingModal::Open in new tab'), onClick: (selectedIndex: number) => {
          const selectedAttachment = attachments[selectedIndex]

          if (selectedAttachment) window.open(selectedAttachment.url, "_blank");
        }
      }]
    })
  }

  onContactChange(contactId: string, contact: Contact) {
    const { incomingSelfBillingOrder } = this.state;

    this.setState({
      incomingSelfBillingOrder: {
        ...incomingSelfBillingOrder,
        contact_id: contactId,
        contact: contact,
      }
    });
  }

  onPaidOnChange(paidOn) {
    const { incomingSelfBillingOrder } = this.state;

    const newPaidOn = moment(paidOn)

    this.setState({
      incomingSelfBillingOrder: {
        ...incomingSelfBillingOrder,
        paid_on: newPaidOn.isValid() ? newPaidOn.format('YYYY-MM-DD') : null
      }
    });
  }

  onBookedOnChange(value) {
    const { incomingSelfBillingOrder } = this.state;

    const bookedOn = value ? moment(value).format('YYYY-MM-DD') : null

    this.setState({
      incomingSelfBillingOrder: {
        ...incomingSelfBillingOrder,
        booked_on: bookedOn,
      },
    })
  }

  onFormSubmit(e?: any) {
    if (e) e.preventDefault();
    const { incomingSelfBillingOrder } = this.state;
    const { close, onSubmit, t } = this.props

    this.setState({ isSubmitting: true })
    IncomingSelfBillingOrdersController
      .update(incomingSelfBillingOrder)
      .then(response => {
        const { errors, error_full_messages } = response;

        if (errors) {
          this.setState({
            errors: errors
          });
          Notification.notifyError(t('IncomingSelfBillingModal::Oops something went wrong'))
        }
        else {
          Notification.notifySuccess(t('IncomingSelfBillingModal::Order successfully updated'))
          if (onSubmit) onSubmit(response)
          close()
        }

        this.setState({ isSubmitting: false })
      })
      .catch(error => console.error(error))
  }

  onIncomingSelfBillingModalClose() {
    this.props.close()
  }

  onErrorsDismiss() {
    this.setState({
      errors: {}
    })
  }

  renderDetails() {
    const { currentUser: { workspace: { setting } }, supplierDisabled, t, contactDisabled, projectDisabled } = this.props
    const { incomingSelfBillingOrder, currencies } = this.state

    const currencyOptions = currencies.map((currency) => ({ label: currency.label, value: currency.value, symbol: currency.symbol }))
    const selectedCurrencyOption = currencyOptions.find(option => option.value === incomingSelfBillingOrder.currency)

    const typeOptions = Object.keys(IncomingSelfBillingOrderType).map(key => (
      { label: IncomingSelfBillingOrderHelper.getTypeLabel(IncomingSelfBillingOrderType[key]), value: IncomingSelfBillingOrderType[key] }
    ))
    const selectedTypeOption = typeOptions.find(option => option.value === incomingSelfBillingOrder.type)

    return (
      <>
        <IncomingSelfBillingOrderHeader>
          <SidebarClose onClick={this.onIncomingSelfBillingModalClose} />

          <IncomingSelfBillingOrderHeaderTitle>
            <span>
              {incomingSelfBillingOrder?.contact?.name || t('IncomingSelfBillingModal::No client selected')}
            </span>

          </IncomingSelfBillingOrderHeaderTitle>

          <IncomingSelfBillingOrderHeaderAmountContainer>
            <IncomingSelfBillingOrderHeaderAmount>
              {NumberFormatter.formatCurrency(incomingSelfBillingOrder.currency, setting.number_format, incomingSelfBillingOrder.amount || 0)}
            </IncomingSelfBillingOrderHeaderAmount>
            <IncomingSelfBillingOrderHeaderVatDescription>
              {t('IncomingSelfBillingModal::incl. VAT')}
            </IncomingSelfBillingOrderHeaderVatDescription>
          </IncomingSelfBillingOrderHeaderAmountContainer>
          <SidebarDivider />
        </IncomingSelfBillingOrderHeader>

        <div className='grid'>
          <div className='grid-cell with-12col'>
            <div className='form-item'>
              <label>
                {t('IncomingSelfBillingModal::Number')}<span>*</span>
              </label>
              <input
                type='text'
                name='name'
                value={incomingSelfBillingOrder.number}
                placeholder={t('IncomingSelfBillingModal::Name')}
                autoComplete='off'
                readOnly
              />
            </div>
          </div>

          <div className='grid-cell with-12col'>
            <div className='form-item'>
              <label>
                {t('IncomingSelfBillingModal::Client')}
              </label>
              <ResourceCreatablePowerSelect
                type='contact'
                params={{ archived: false }}
                value={incomingSelfBillingOrder.contact_id}
                isDisabled={contactDisabled}
                isClearable={true}
                placeholder={t('IncomingSelfBillingModal::Select a client...')}
                onChange={this.onContactChange}
              />
            </div>
          </div>

          <div className='grid-cell with-6col'>
            <div className='form-item'>
              <label>
                {t('IncomingSelfBillingModal::Amount (excl. VAT)')}<span>*</span>
              </label>
              <MoneyInput
                ref={this.netAmountInput}
                name='amount'
                currency={incomingSelfBillingOrder.currency}
                numberFormat={setting.number_format}
                placeholderValue={0}
                value={incomingSelfBillingOrder.net_total}
                onBlur={() => { }}
                disabled
              />
            </div>
          </div>


          <div className='grid-cell with-6col'>
            <div className='form-item'>
              <label>
                {t('IncomingSelfBillingModal::Amount')}<span>*</span>
              </label>
              <MoneyInput
                ref={this.amountInput}
                name='amount'
                currency={incomingSelfBillingOrder.currency}
                numberFormat={setting.number_format}
                placeholderValue={0}
                value={incomingSelfBillingOrder.amount}
                onBlur={() => { }}
                disabled
              />
            </div>
          </div>

          <div className='grid-cell with-6col'>
            <div className='form-item'>
              <label>{t('IncomingSelfBillingModal::Invoiced on')} <span>*</span></label>
              <DateInput
                ref={this.invoicedOnInput}
                name='invoiced_on'
                dateFormat={setting.date_format}
                timeFormat={false}
                initialValue={moment(incomingSelfBillingOrder.issue_date)}
                inputProps={{ placeholder: setting.date_format, readOnly: true }}
                onChange={() => { }}
                closeOnSelect={true}
              />
            </div>
          </div>

          <div className='grid-cell with-6col'>
            <div className='form-item'>
              <label>{t('IncomingSelfBillingModal::Due date')}</label>
              <DateInput
                ref={this.dueOnInput}
                name='due_on'
                dateFormat={setting.date_format}
                timeFormat={false}
                initialValue={moment(incomingSelfBillingOrder.due_date)}
                inputProps={{ placeholder: setting.date_format, readOnly: true }}
                onChange={() => { }}
                closeOnSelect={true}
              />
            </div>
          </div>

          <div className='grid-cell with-6col'>
            <div className='form-item'>
              <label>
                {t('IncomingSelfBillingModal::Type')} <span>*</span>
              </label>
              <PowerSelect
                options={typeOptions}
                value={selectedTypeOption}
                noOptionsMessage={() => t('IncomingSelfBillingModal::No type found')}
                theme={ReactSelectTheme}
                isDisabled
              />
            </div>
          </div>

          <div className='grid-cell with-6col'>
            <div className='form-item'>
              <label>{t('IncomingSelfBillingModal::Currency')} <span>*</span></label>

              <PowerSelect
                options={currencyOptions}
                value={selectedCurrencyOption}
                noOptionsMessage={() => t('IncomingSelfBillingModal::No currency found')}
                theme={ReactSelectTheme}
                isDisabled
              />
            </div>
          </div>
        </div>

        <SidebarDivider />

        <IncomingSelfBillingOrderSectionTitle>
          {t('IncomingSelfBillingModal::Billing details')}
        </IncomingSelfBillingOrderSectionTitle>

        <div className='grid'>
          <div className='grid-cell with-12col'>
            <div className='form-item'>
              <label>
                {t('IncomingSelfBillingModal::Remittance information')}
              </label>

              <RemittanceInformationInput
                value={incomingSelfBillingOrder.remittance_information}
                type={incomingSelfBillingOrder.remittance_information_type}
                onRemittanceInformationChange={() => { }}
                onRemittanceInformationTypeChange={() => { }}
                isDisabled
              />
            </div>
          </div>

          <div className='grid-cell with-12col'>
            <div className='form-item'>
              <label>{t('IncomingSelfBillingModal::Payment date')}</label>
              <DateInput
                ref={this.paidOnInput}
                name='paid_on'
                dateFormat={setting.date_format}
                timeFormat={false}
                initialValue={moment(incomingSelfBillingOrder.paid_on)}
                inputProps={{ placeholder: setting.date_format }}
                closeOnSelect={true}
                onChange={this.onPaidOnChange}
              />
            </div>
          </div>
        </div>

        <SidebarDivider />

        <IncomingSelfBillingOrderSectionTitle>
          {t('IncomingSelfBillingModal::Additional information')}
        </IncomingSelfBillingOrderSectionTitle>

        <div className='grid'>
          <div className='grid-cell with-12col'>
            <div className='form-item'>
              <label>
                {t('IncomingSelfBillingModal::Booked on')}

                <Tooltip
                  content={t('IncomingSelfBillingModal::The date when this order was booked in your accounting system. When an accounting integration is enabled, this date will be automatically filled in.')}
                  containerStyle={{ marginLeft: 8 }}
                />
              </label>
              <DateInput
                name='booked_on'
                dateFormat={setting.date_format}
                timeFormat={false}
                initialValue={moment(incomingSelfBillingOrder.booked_on)}
                inputProps={{ placeholder: setting.date_format }}
                onChange={this.onBookedOnChange}
              />
            </div>
          </div>
        </div>
      </>
    )
  }

  render() {
    const { t } = this.props
    const { incomingSelfBillingOrder, didInitialLoad, errors, isSubmitting } = this.state

    return (
      <Container>
        {!didInitialLoad && <LoaderContainer>
          <Loader
            color='white'
            size='large'
          />
        </LoaderContainer>}
        {didInitialLoad && <>
          <PreviewContainer>
            {incomingSelfBillingOrder.attachment_url && <PreviewWrapper noPadding={['application/pdf', 'text/xml', 'application/xml'].includes(incomingSelfBillingOrder.attachment_content_type)}>
              <AttachmentPreviewer
                filename={incomingSelfBillingOrder.attachment_file_name}
                source={incomingSelfBillingOrder.attachment_url}
                contentType={incomingSelfBillingOrder.attachment_content_type}
              />
            </PreviewWrapper>}


            {incomingSelfBillingOrder.attachment_url && <PreviewActions>
              <SimpleTooltip content={t('IncomingSelfBillingModal::Download')}>
                <PreviewAction onClick={this.onFileDownloadClick}>
                  <Icon icon='download-circle' />
                  {t('IncomingSelfBillingModal::Download')}
                </PreviewAction>
              </SimpleTooltip>
            </PreviewActions>}
          </PreviewContainer>

          <SidebarContainer>
            <SidebarContent>
              <form onSubmit={this.onFormSubmit}>
                {this.renderDetails()}
                <input type='submit' style={{ display: 'none' }} />
              </form>
            </SidebarContent>

            <SidebarDivider />

            <SidebarFooter>
              <Button
                type='outline'
                text={t('IncomingSelfBillingModal::Close')}
                onClick={this.onIncomingSelfBillingModalClose}
              />
              <div key='main-action' className='popover-wrapper'>
                <TooltipError
                  errors={errors}
                  onDismiss={this.onErrorsDismiss}
                />

                <Button
                  type='success'
                  text={t('IncomingSelfBillingModal::Save')}
                  isLoading={isSubmitting}
                  onClick={this.onFormSubmit}
                  style={{ width: '100%' }}
                />
              </div>
            </SidebarFooter>
          </SidebarContainer>
        </>}
      </Container>
    )
  }
}

const mapStateToProps = (state: AppState): IStateToProps => {
  const {
    authentication: {
      currentUser
    },
    modals: {
      incomingSelfBillingModal: {
        incomingSelfBillingOrder,
        onSubmit,
      }
    }
  } = state

  return {
    incomingSelfBillingOrder: incomingSelfBillingOrder,
    onSubmit: onSubmit,
    currentUser: currentUser,
  }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): IDispatchToProps => {
  return {
    close: () => dispatch(closeIncomingSelfBillingOrderModal()),
    showAttachmentsViewerModal: (options) => dispatch(showAttachmentsViewerModal(options)),
    showContactModal: (options) => dispatch(showContactModal(options)),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(IncomingSelfBillingModal)) as any) as any